import { InputAdornmentClassKey } from '@material-ui/core/InputAdornment';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const THDInputAdornmentStyles: Partial<
  Record<InputAdornmentClassKey, CSSProperties>
> = {};
